<div class="account_settings">

    <form [formGroup]="profile_form">

        <h2 class="fnt-20 myAccount-titles">Personal Information</h2>

        <div class="d__flex personal__info">
            <div class="input__item">
                <p class="input__title">Full Name</p>
                <div class="custom-input" [class.focused]="focus.first_name">
                    <ion-input readonly [disabled]="true"  (ionFocus)="focus.first_name = true" (ionBlur)="focus.first_name = false" placeholder="Name" name="first_name" formControlName="first_name" [(ngModel)]="userinfo.first_name"></ion-input>
                </div>
                <div *ngIf="submitted &&  !first_name?.valid && ( first_name?.dirty|| first_name?.touched) ">
                    <p class="m-0 errors" *ngIf="first_name.errors.required">Name is required</p>
                    <p class="m-0 errors" *ngIf="first_name.errors.maxlength">Name is not valid</p>
                </div>
            </div>

            <div class="input__item" lines="none">
                <p class="input__title">Email</p>
                <div class="custom-input" [class.focused]="focus.email">
                    <ion-input readonly (ionFocus)="focus.email = true" [disabled]="true" readonly (ionBlur)="focus.email = false" placeholder="Email" type="email" name="email" formControlName="email" [(ngModel)]="userinfo.email"></ion-input>
                </div>
                <div *ngIf="submitted && !email?.valid">
                    <p class="error" *ngIf="email.errors.required">Email-Id is required</p>
                    <p class="error" *ngIf="email.errors.email">Email-Id is not valid</p>
                </div>
            </div>

            <div class="input__item" lines="none">
                <p class="input__title">Phone Number</p>
                <div class="custom-input" [class.focused]="focus.phone">
                    <ion-input readonly [disabled]="true" readonly (ionFocus)="focus.phone = true" (ionBlur)="focus.phone = false" placeholder="Phone Number" type="number" name="phone" formControlName="phone" [(ngModel)]="userinfo.phone"></ion-input>
                </div>
                <div *ngIf="submitted && !phone?.valid">
                    <p class="m-0 errors" *ngIf="phone.errors.required"> Phone Number is required </p>
                    <p class="m-0 errors" *ngIf="phone.errors.pattern"> Not a Valid Mobile number </p>
                </div>
            </div>

            <div *ngIf="false" class="input__item">
                <p class="input__title">Business Name</p>
                <div class="custom-input" [class.focused]="focus.business_name">
                    <ion-input readonly [disabled]="true"  (ionFocus)="focus.business_name = true" (ionBlur)="focus.business_name = false" placeholder="Business Name" name="business_name" formControlName="business_name" [(ngModel)]="customer_info.business_name"></ion-input>
                </div>
                <div *ngIf="submitted &&  !business_name?.valid && ( business_name?.dirty|| business_name?.touched) ">
                    <p class="m-0 errors" *ngIf="business_name.errors.required">Business Name is required</p>
                    <p class="m-0 errors" *ngIf="business_name.errors.maxlength">Business Name is not valid</p>
                </div>
            </div>

            <div *ngIf="false" class="input__item">
                <p class="input__title">Store Name</p>
                <div class="custom-input" [class.focused]="focus.store_name">
                    <ion-input readonly [disabled]="true"  (ionFocus)="focus.store_name = true" (ionBlur)="focus.store_name = false" placeholder="Business Name" name="store_name" formControlName="store_name" [(ngModel)]="customer_info.store_name"></ion-input>
                </div>
                <div *ngIf="submitted &&  !store_name?.valid && (store_name?.dirty|| store_name?.touched) ">
                    <p class="m-0 errors" *ngIf="store_name.errors.required">Business Name is required</p>
                    <p class="m-0 errors" *ngIf="store_name.errors.maxlength">Business Name is not valid</p>
                </div>
            </div>

            <div *ngIf="false" class="input__item" lines="none">
                <p class="input__title">Business Phone Number</p>
                <div class="custom-input" [class.focused]="focus.business_phone">
                    <ion-input readonly [disabled]="true" readonly (ionFocus)="focus.business_phone = true" (ionBlur)="focus.business_phone = false" placeholder="Business Phone Number" type="number" name="business_phone" formControlName="business_phone" [(ngModel)]="customer_info.business_phone"></ion-input>
                </div>
                <div *ngIf="submitted && !business_phone?.valid">
                    <p class="m-0 errors" *ngIf="business_phone.errors.required"> Business Phone Number is required </p>
                    <p class="m-0 errors" *ngIf="business_phone.errors.pattern"> Not a Valid Business Phone number </p>
                </div>
            </div>

            <div *ngIf="false" class="input__item">
                <p class="input__title">Business Address</p>
                <div class="custom-input" [class.focused]="focus.business_address">
                    <ion-textarea readonly [disabled]="true"  class="text-area" [(ngModel)]="userinfo.business_address" formControlName="business_address" placeholder="Business Address"></ion-textarea>
                    <!-- <ion-input (ionFocus)="focus.business_name = true" (ionBlur)="focus.business_name = false" placeholder="Business Name" name="business_name" formControlName="business_name" [(ngModel)]="userinfo.business_name"></ion-input> -->
                </div>
                <div *ngIf="submitted &&  !business_address?.valid && ( business_address?.dirty|| business_address?.touched) ">
                    <p class="m-0 errors" *ngIf="business_address.errors.required">Business Name is required</p>
                    <p class="m-0 errors" *ngIf="business_address.errors.maxlength">Business Name is not valid</p>
                </div>
            </div>

        </div>

        <div *ngIf="false" class="divider"></div>

        <h2 *ngIf="false" class="fnt-20 myAccount-titles">Account Information</h2>

        <div *ngIf="false" class="d__flex account__info p-10">
            <div class="input__item" lines="none">
                <p class="input__title">Email</p>
                <div class="custom-input" [class.focused]="focus.email">
                    <ion-input (ionFocus)="focus.email = true" [disabled]="true" readonly (ionBlur)="focus.email = false" placeholder="Email" type="email" name="email" formControlName="email" [(ngModel)]="userinfo.email"></ion-input>
                </div>
                <div *ngIf="submitted && !email?.valid">
                    <p class="error" *ngIf="email.errors.required">Email-Id is required</p>
                    <p class="error" *ngIf="email.errors.email">Email-Id is not valid</p>
                </div>
            </div>

        </div>

        <div *ngIf="false" class="divider"></div>



        <div *ngIf="false" class="mt-10 mb-10" [ngClass]="db.ismobile?'ion-text-center':'ion-text-right'">
            <!-- <ion-button class="action-button" [class.w-20]="!db.ismobile" fill="clear" (click)="update()">Save</ion-button> -->
        </div>

    </form>
    
</div>